/* NicheGems: small progressive enhancements. Everything works without this file. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* country and language selects, and the collection filters, submit on change */
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el || !el.matches || !el.form) return;
    if (el.matches('[data-ng-autosubmit]') || el.form.matches('[data-ng-autosubmit-form]')) {
      if (el.type === 'number') return; /* price fields: wait for Enter or the Apply button */
      var sheet = el.closest('[data-ng-fsheet]');
      if (sheet && sheet.dataset.ngModal === '1') return; /* phone filter sheet: wait for "Show perfumes" */
      el.form.submit();
    }
  });

  /* collection filters: "show all" in a long list */
  document.addEventListener('click', function (event) {
    var more = event.target.closest && event.target.closest('[data-ng-facet-more]');
    if (!more) return;
    var group = more.closest('.ng-facet');
    if (group) group.classList.add('ng-facet--all');
  });

  /* collection filters on phones: the groups open as a sheet (a modal dialog) from one "Filter" button */
  function initFacetSheet() {
    var sheet = document.querySelector('[data-ng-fsheet]');
    var opener = document.querySelector('[data-ng-fsheet-open]');
    if (!sheet || !opener || typeof sheet.showModal !== 'function' || !window.matchMedia) return;
    var phone = window.matchMedia('(max-width: 749px)');
    function unlock() { document.documentElement.classList.remove('ng-lock'); sheet.dataset.ngModal = '0'; }
    function sync() {
      if (phone.matches) {
        if (sheet.dataset.ngModal !== '1') sheet.removeAttribute('open');
      } else {
        if (sheet.dataset.ngModal === '1') sheet.close();
        unlock();
        sheet.setAttribute('open', '');
      }
    }
    sync();
    if (phone.addEventListener) phone.addEventListener('change', sync);
    opener.addEventListener('click', function () {
      if (!phone.matches) return;
      sheet.removeAttribute('open');
      sheet.showModal();
      sheet.dataset.ngModal = '1';
      document.documentElement.classList.add('ng-lock');
    });
    sheet.addEventListener('close', function () { unlock(); opener.focus(); });
    sheet.addEventListener('click', function (event) {
      if (sheet.dataset.ngModal !== '1') return;
      if (event.target === sheet || (event.target.closest && event.target.closest('[data-ng-fsheet-close]'))) sheet.close();
    });
  }
  /* cookie banner: the sentence is clamped to two lines on phones, a tap opens it in full */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest || t.closest('a')) return;
    var p = t.closest('#shopify-pc__banner p');
    if (p) p.closest('#shopify-pc__banner').classList.toggle('ng-open');
  });

  /* article figures: a photo that does not load takes its figure with it (no broken image, the text stays) */
  document.addEventListener('error', function (event) {
    var img = event.target;
    if (!img || img.tagName !== 'IMG' || !img.closest) return;
    var fig = img.closest('.ng-fig');
    if (fig) fig.classList.add('ng-fig--gone');
  }, true);

  /* "read more" for clamped text: the button shows only when the text is really cut */
  function initClamp(scope) {
    (scope || document).querySelectorAll('[data-ng-clamp]').forEach(function (el) {
      var btn = el.parentNode.querySelector('[data-ng-more]');
      if (!btn || btn.dataset.ngReady) return;
      btn.dataset.ngReady = '1';
      function check() {
        if (el.classList.contains('ng-open')) return;
        btn.hidden = !(el.scrollHeight > el.clientHeight + 6);
      }
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('ng-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
      check();
      window.addEventListener('resize', check);
    });
  }

  /* close an open filter panel when another opens or on a click outside */
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.ng-facet[open]').forEach(function (d) {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });

  /* rails: previous and next buttons, hidden when everything fits */
  function initRail(wrap) {
    var rail = wrap.querySelector('[data-ng-rail-track]');
    var nav = wrap.querySelector('[data-ng-rail-nav]') || document.querySelector('[data-ng-rail-nav="' + wrap.id + '"]');
    if (!rail || !nav) return;
    var prev = nav.querySelector('[data-ng-rail-prev]');
    var next = nav.querySelector('[data-ng-rail-next]');
    if (!prev || !next) return;

    function step() {
      var item = rail.firstElementChild;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var size = item ? item.getBoundingClientRect().width + gap : rail.clientWidth;
      return Math.max(size, Math.floor(rail.clientWidth / size) * size);
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      nav.hidden = max <= 4;
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft >= max - 4;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
    update();
  }

  /* product gallery: one sideways track of photos (it swipes by itself); thumbnails and arrow keys move it,
     a click on a photo opens it large in a dialog */
  function initGallery(root) {
    var track = root.querySelector('[data-ng-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ng-gallery-thumb]'));
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    function mark(i) {
      index = i;
      thumbs.forEach(function (b, n) { b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var t = thumbs[i];
      var list = t && t.closest('.ng-pdp__thumbs');
      if (!list) return;
      /* keep the current thumbnail inside its own strip, without moving the page */
      var li = t.parentNode;
      if (li.offsetLeft < list.scrollLeft) list.scrollLeft = li.offsetLeft;
      else if (li.offsetLeft + li.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollLeft = li.offsetLeft + li.offsetWidth - list.clientWidth;
      if (li.offsetTop < list.scrollTop) list.scrollTop = li.offsetTop;
      else if (li.offsetTop + li.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = li.offsetTop + li.offsetHeight - list.clientHeight;
    }
    function go(i, smooth) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !calm ? 'smooth' : 'auto' });
      mark(i);
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index && slides[i]) mark(i);
      });
    }, { passive: true });
    thumbs.forEach(function (btn, n) {
      btn.addEventListener('click', function (event) { event.preventDefault(); go(n, true); });
    });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(index - 1, true); }
      if (event.key === 'ArrowRight') { event.preventDefault(); go(index + 1, true); }
    });
    window.addEventListener('resize', function () { track.scrollLeft = index * track.clientWidth; });

    var zoom = root.querySelector('[data-ng-zoom]');
    if (!zoom || typeof zoom.showModal !== 'function') return;
    var big = zoom.querySelector('[data-ng-zoom-img]');
    var opener = null;
    function fill() {
      var btn = slides[index] && slides[index].querySelector('[data-ng-zoom-open]');
      var img = btn && btn.querySelector('img');
      if (!btn) return;
      big.src = btn.getAttribute('data-zoom') || (img && (img.currentSrc || img.src)) || '';
      big.alt = img ? img.alt : '';
    }
    function step(d) { go(index + d, false); fill(); }
    track.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-ng-zoom-open]');
      if (!btn) return;
      var n = slides.indexOf(btn.closest('.ng-pdp__slide'));
      if (n > -1) mark(n);
      opener = btn;
      fill();
      zoom.showModal();
      document.documentElement.classList.add('ng-lock');
    });
    zoom.addEventListener('close', function () {
      document.documentElement.classList.remove('ng-lock');
      var back = slides[index] && slides[index].querySelector('[data-ng-zoom-open]');
      if (back || opener) (back || opener).focus({ preventScroll: true });
    });
    zoom.addEventListener('click', function (event) {
      var t = event.target;
      if (t.closest('[data-ng-zoom-prev]')) step(-1);
      else if (t.closest('[data-ng-zoom-next]')) step(1);
      else zoom.close(); /* the photo itself, the close button or the empty space */
    });
    zoom.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
  }

  /* reveal on scroll: only elements that start below the fold are hidden, and only once this script runs */
  function initReveal(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var limit = window.innerHeight * 1.3; /* what is within a quarter screen below the fold is never hidden */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ng-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 25% 0px', threshold: 0 });
    (scope || document).querySelectorAll('[data-ng-reveal]:not(.ng-reveal)').forEach(function (el) {
      if (el.getBoundingClientRect().top < limit) return;
      el.classList.add('ng-reveal');
      io.observe(el);
    });
  }

  /* phone product page: the bar with one button shows whenever the buy / notify block is out of view
     (before the visitor reaches it and after scrolling past it) */
  function initStickybar() {
    var bar = document.querySelector('[data-ng-stickybar]');
    var buy = document.getElementById('NgBuy');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    if (buy.querySelector('.ng-form__ok')) return; /* the form has just been sent */
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      bar.classList.toggle('ng-on', !e.isIntersecting);
    }, { rootMargin: '-70px 0px -60px 0px', threshold: 0 }).observe(buy);
    var go = bar.querySelector('[data-ng-stickybar-go]');
    if (!go) return;
    go.addEventListener('click', function (event) {
      event.preventDefault();
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      buy.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
      var field = buy.querySelector('input[type="email"]');
      if (field) field.focus({ preventScroll: true });
    });
  }

  /* recently viewed: product handles in the visitor's own browser, only with consent for preferences */
  var RECENT_KEY = 'ng:recent';
  function withConsent(fn) {
    var S = window.Shopify;
    function allowed() {
      try { return !!(S.customerPrivacy && S.customerPrivacy.preferencesProcessingAllowed()); } catch (e) { return false; }
    }
    if (S && S.customerPrivacy) { fn(allowed()); return; }
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { fn(!error && allowed()); });
      return;
    }
    fn(false);
  }
  function readRecent() {
    try {
      var list = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function writeRecent(list) {
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 9))); } catch (e) {}
  }
  function fillRecent(box, list) {
    var track = box.querySelector('[data-ng-recent-list]');
    if (!track || box.dataset.ngFilled) return;
    var current = box.getAttribute('data-current');
    var handles = list.filter(function (h) { return h !== current; }).slice(0, 8);
    if (!handles.length) return;
    box.dataset.ngFilled = '1';
    var root = box.getAttribute('data-root') || '/';
    if (root.slice(-1) !== '/') root += '/';
    Promise.all(handles.map(function (handle) {
      return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=ng-recent-card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return null; });
    })).then(function (parts) {
      var gone = [];
      parts.forEach(function (html, i) {
        if (html === null) return; /* network trouble: keep the handle, show nothing for it */
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var item = tmp.querySelector('[data-ng-recent-item]');
        if (item) track.appendChild(item);
        else gone.push(handles[i]); /* the product no longer exists */
      });
      if (gone.length) writeRecent(readRecent().filter(function (h) { return gone.indexOf(h) === -1; }));
      if (!track.children.length) return;
      box.classList.add('ng-on');
      var rail = box.querySelector('[data-ng-rail]');
      if (rail) initRail(rail);
    });
  }
  function initRecent() {
    var here = document.querySelector('[data-ng-product]');
    var boxes = document.querySelectorAll('[data-ng-recent]');
    if (!here && !boxes.length) return;
    function run(ok) {
      if (!ok) return;
      var list = readRecent();
      boxes.forEach(function (box) { fillRecent(box, list); });
      if (here) {
        var handle = here.getAttribute('data-ng-product');
        if (handle) writeRecent([handle].concat(list.filter(function (h) { return h !== handle; })));
      }
    }
    withConsent(run);
    /* the visitor answers the cookie banner on this page: start, or forget what was kept */
    document.addEventListener('visitorConsentCollected', function (event) {
      var d = event.detail || {};
      if (d.preferencesAllowed) run(true);
      else { try { window.localStorage.removeItem(RECENT_KEY); } catch (e) {} }
    });
  }

  /* mobile menu: one group open at a time per level (also where <details name> is not supported) */
  document.addEventListener('toggle', function (event) {
    var d = event.target;
    if (!d || !d.open || !d.classList || !d.classList.contains('ng-dnav__group')) return;
    var item = d.parentNode;
    var list = item && item.parentNode;
    if (!list) return;
    Array.prototype.forEach.call(list.children, function (li) {
      if (li === item) return;
      var other = li.querySelector(':scope > .ng-dnav__group[open]');
      if (other) other.removeAttribute('open');
    });
  }, true);

  /* footer link columns: accordions on phones, always open on wider screens */
  function initFooterAcc() {
    var list = document.querySelectorAll('[data-ng-footer-acc]');
    if (!list.length || !window.matchMedia) return;
    var phone = window.matchMedia('(max-width: 749px)');
    function apply() {
      list.forEach(function (d) {
        if (phone.matches) d.removeAttribute('open');
        else d.setAttribute('open', '');
      });
    }
    apply();
    if (phone.addEventListener) phone.addEventListener('change', apply);
  }

  ready(function () {
    initStickybar();
    initFooterAcc();
    initFacetSheet();
    if ('requestIdleCallback' in window) window.requestIdleCallback(initRecent, { timeout: 2500 });
    else window.setTimeout(initRecent, 800);
    initReveal(document);
    document.querySelectorAll('[data-ng-rail]').forEach(initRail);
    document.querySelectorAll('[data-ng-gallery]').forEach(initGallery);
    initClamp(document);
  });

  /* theme editor: sections can be re-rendered */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ng-rail]').forEach(initRail);
    event.target.querySelectorAll('[data-ng-gallery]').forEach(initGallery);
    initClamp(event.target);
  });
})();
